// shared-components/ui/PageLoader.jsx
import LoadingSpinner from "./LoadingSpinner";
import { useSiteGradients } from "@shared/hooks";

function PageLoader() {
  const gradients = useSiteGradients();
  return (
    <div
      className={`min-h-screen flex items-center justify-center ${gradients.layoutMain}`}
    >
      <LoadingSpinner size="lg" />
    </div>
  );
}

export default PageLoader;
